import accountService from '../api/account.js'

// initial state
const state = {

  // STORAGE KEYS
  emailStorageKey: 'emailStorageKey',
  userInstanceIdStorageKey: 'userInstanceIdStorageKey',
  accessTokenStorageKey: 'accessTokenStorageKey',
  accessTokenExpirationTimeStorageKey: 'accessTokenExpirationTimeStorageKey',
  refreshTokenStorageKey: 'refreshTokenStorageKey',
  // VARS
  email: '',
  userInstanceId: '',
  accessToken: '',
  accessTokenExpirationTime: 0,
  refreshToken: '',

  // REGISTER
  registerStatus: 'idle',
  registerErrorMessage: '',

  // REQUEST PASSWORD
  requestPasswordStatus: 'idle',
  requestPasswordErrorMessage: '',

  // VERIFY MAIL
  verifyMailStatus: 'idle',
  verifyMailErrorMessage: '',

  // FINALIZE ACCOUNT
  finalizeAccountStatus: 'idle',
  finalizeAccountErrorMessage: '',

  // RESET PASSWORD
  resetPasswordStatus: 'idle',
  resetPasswordErrorMessage: '',
}

// getters
const getters = {

  // STORAGE KEYS
  emailStorageKey: state => { return state.emailStorageKey },
  userInstanceIdStorageKey: state => { return state.userInstanceIdStorageKey },
  accessTokenStorageKey: state => { return state.accessTokenStorageKey },
  accessTokenExpirationTimeStorageKey: state => { return state.accessTokenExpirationTimeStorageKey },
  refreshTokenStorageKey: state => { return state.refreshTokenStorageKey },
  // VARS
  email: state => { return state.email },
  userInstanceId: state => { return state.userInstanceId },
  accessToken: state => { return state.accessToken },
  accessTokenExpirationTime: state => { return state.accessTokenExpirationTime },
  refreshToken: state => { return state.refreshToken },

  // REGISTER
  registerStatus: state => { return state.registerStatus },
  registerErrorMessage: state => { return state.registerErrorMessage },

  // REQUEST PASSWORD
  requestPasswordStatus: state => { return state.requestPasswordStatus },
  requestPasswordErrorMessage: state => { return state.requestPasswordErrorMessage },

  // VERIFY MAIL
  verifyMailStatus: state => { return state.verifyMailStatus },
  verifyMailErrorMessage: state => { return state.verifyMailErrorMessage },

  // FINALIZE ACCOUNT
  finalizeAccountStatus: state => { return state.finalizeAccountStatus },
  finalizeAccountErrorMessage: state => { return state.finalizeAccountErrorMessage },

  // RESET PASSWORD
  resetPasswordStatus: state => { return state.resetPasswordStatus },
  resetPasswordErrorMessage: state => { return state.resetPasswordErrorMessage },
}

// mutations
const mutations = {
  ['EMAIL_SET'] (state, email) {
    state.email = email
  },

  ['REGISTRATION_RESULTS_SET'] (state, results) {
    state.userInstanceId = results.user_instance_id
    state.accessToken = results.access_token
    state.accessTokenExpirationTime = results.access_token_expiration_time
    state.refreshToken = results.refresh_token
  },
  ['REGISTRATION_STATUS_SET'] (state, registerStatus) {
    state.registerStatus = registerStatus
  },
  ['REGISTRATION_ERROR_SET'] (state, error) {
    state.registerErrorMessage = error.body.message
  },

  ['REQUEST_RESET_PASSWORD_STATUS_SET'] (state, requestPasswordStatus) {
    state.requestPasswordStatus = requestPasswordStatus
  },
  ['REQUEST_RESET_PASSWORD_ERROR_SET'] (state, error) {
    state.requestPasswordErrorMessage = error.body.message
  },

  ['VERIFY_MAIL_STATUS_SET'] (state, verifyMailStatus) {
    state.verifyMailStatus = verifyMailStatus
  },
  ['VERIFY_MAIL_ERROR_SET'] (state, error) {
    state.verifyMailErrorMessage = error.body.message
  },

  ['FINALIZE_ACCOUNT_STATUS_SET'] (state, finalizeAccountStatus) {
    state.finalizeAccountStatus = finalizeAccountStatus
  },
  ['FINALIZE_ACCOUNT_ERROR_SET'] (state, error) {
    state.finalizeAccountErrorMessage = error.body.message
  },

  ['RESET_PASSWORD_STATUS_SET'] (state, resetPasswordStatus) {
    state.resetPasswordStatus = resetPasswordStatus
  },
  ['RESET_PASSWORD_ERROR_SET'] (state, error) {
    state.resetPasswordErrorMessage = error.body.message
  },
}

// actions
const actions = {
  ['REGISTER'] ({commit}, payload) {
    commit('REGISTRATION_STATUS_SET', 'progress')
    return accountService.registerAccount(payload)
      .then((response) => {
        commit('REGISTRATION_RESULTS_SET', response)
        commit('REGISTRATION_STATUS_SET', 'done')
        return Promise.resolve(response)
      })
      .catch((error) => {
        commit('REGISTRATION_STATUS_SET', 'error')
        commit('REGISTRATION_ERROR_SET', error)
        return Promise.reject(error)
      })
  },
  ['REQUEST_RESET_PASSWORD'] ({commit}, payload) {
    commit('REQUEST_RESET_PASSWORD_STATUS_SET', 'progress')
    return accountService.requestResetPassword(payload)
      .then((response) => {
        commit('REQUEST_RESET_PASSWORD_STATUS_SET', 'done')
      })
      .catch((error) => {
        commit('REQUEST_RESET_PASSWORD_ERROR_SET', error)
        commit('REQUEST_RESET_PASSWORD_STATUS_SET', 'error')
      })
  },
  ['VERIFY_MAIL'] ({commit}, payload) {
    commit('VERIFY_MAIL_STATUS_SET', 'progress')
    return accountService.verifyMail(payload)
      .then((response) => {
        commit('VERIFY_MAIL_STATUS_SET', 'done')
        return Promise.resolve(response)
      })
      .catch((error) => {
        commit('VERIFY_MAIL_ERROR_SET', error)
        commit('VERIFY_MAIL_STATUS_SET', 'error')
        return Promise.reject(error)
      })
  },
  ['FINALIZE_ACCOUNT'] ({commit}, payload) {
    commit('FINALIZE_ACCOUNT_STATUS_SET', 'progress')
    return accountService.finalizeAccount(payload)
      .then((response) => {
        commit('FINALIZE_ACCOUNT_STATUS_SET', 'done')
        return Promise.resolve(response)
      })
      .catch((error) => {
        commit('FINALIZE_ACCOUNT_ERROR_SET', error)
        commit('FINALIZE_ACCOUNT_STATUS_SET', 'error')
        return Promise.reject(error)
      })
  },
  ['RESET_PASSWORD'] ({commit}, payload) {
    commit('RESET_PASSWORD_STATUS_SET', 'progress')
    return accountService.resetPassword(payload)
      .then((response) => {
        commit('RESET_PASSWORD_STATUS_SET', 'done')
        return Promise.resolve(response)
      })
      .catch((error) => {
        commit('RESET_PASSWORD_ERROR_SET', error)
        commit('RESET_PASSWORD_STATUS_SET', 'error')
        return Promise.reject(error)
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
